import { MemberToAdd } from "./types";
import consts from "./consts";

export function isIEBrowser() {

  let ua = window.navigator.userAgent;
  let msie = ua.indexOf("MSIE ");

  // If Internet Explorer, return version number
  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    return true;
  }
  return false
  // let win: any = window
  // let chrome = false
  // try {
  //   chrome = !!win.chrome && (!!win.chrome.webstore || !!win.chrome.runtime);
  // } catch (error) {
  //   chrome = false
  // }

  // return !chrome
}

export function isMobile() {
  return window.matchMedia("only screen and (max-width: 760px)").matches;
}

export function getPropertyByKeys(object: any, keys: string[]) {
  for (let i = 0; i < keys.length; i++) {
    let key = keys[i];
    if (object.hasOwnProperty(key)) {
      object = object[key];
    } else {
      return null;
    }
  }
  return object;
}

export function sortAlphabetical(a: any, b: any) {
  if (a.Name && b.Name) {
    if (a.Name.toLowerCase() < b.Name.toLowerCase()) {
      return -1;
    } else {
      return 1;
    }
  } else {
    return -1;
  }
}

export function zeroPad(num: number, places: number): string {
  return String(num).padStart(places, "0");
}

export function timerString(timeElapsed: number) {
  return (
    zeroPad(Math.floor(timeElapsed / 60), 2) +
    ":" +
    zeroPad(Math.floor(timeElapsed % 60), 2)
  );
}


export function randomvideoloadinggif(): string {
  const videoloadinggifs = [
    // "https://orai-misc-data.ams3.cdn.digitaloceanspaces.com/EnterpriseDashboard/video2.gif",
    "https://orai-misc-data.ams3.cdn.digitaloceanspaces.com/EnterpriseDashboard/loading.gif",
    // "https://i.imgur.com/5glhLfD.gif"
  ]
  return videoloadinggifs[Math.floor(Math.random() * videoloadinggifs.length)];
}
export function validateEmail(email: string) {
  let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function validateMembers(members: MemberToAdd[]) {
  if (members && members.length) {
    for (let i = 0; i < members.length; i++) {
      let member = members[i];
      if (
        !member.name.length ||
        !validateEmail(member.email) ||
        (member.role !== "user" && member.role !== "manager" && member.role !== "reviewer")
      ) {
        return false;
      }
    }
    return true;
  }
  return false;
}

export function spaceUppercases(str: string) {
  return str.replace(/([A-Z])/g, " $1").trim();
}

export function percentFromTotal(part: number, total: number) {
  if (total === 0) { return 0; }
  return Math.round((part / total) * 1000) / 10;
}

export function roundPercentage(percentageArray: number[]): number[] {

  let total = percentageArray.reduce((a, b) => a + b, 0);
  let roundPercentageArray = [];
  let totalPercentage = 0

  for (let index in percentageArray) {
    let percentage = 0
    if (total > 0) {
      percentage = Math.round((percentageArray[index] / total) * 100);
    }
    totalPercentage += percentage
    roundPercentageArray.push(percentage)
  }

  if (totalPercentage > 0 && totalPercentage !== 100) {
    let index = percentageArray.indexOf(Math.max.apply(Math, percentageArray));
    percentageArray[index] = percentageArray[index] - (totalPercentage - 100);
    return roundPercentage(percentageArray);
  }

  return roundPercentageArray;
}

export function secondsToText(seconds: number) {
  const minutes = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  const secondsString = (s < 10 ? "0" : "") + s;
  return minutes + ":" + secondsString;
}

export function parseAuthToken(token: string) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace("-", "+").replace("_", "/");
  return JSON.parse(window.atob(base64));
}

export function parseEmbedLink(url: string) {
  let youtubeRegEx = /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/;
  let vimeoRegEx = /(http|https)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/;

  let matchedYoutube = url.match(youtubeRegEx);
  if (matchedYoutube && matchedYoutube.length >= 2) {
    return `https://www.youtube.com/embed/${matchedYoutube[1]}`;
  }

  let matchedVimeo = url.match(vimeoRegEx);
  if (matchedVimeo && matchedVimeo.length >= 5) {
    return `https://player.vimeo.com/video/${matchedVimeo[4]}?color=ffffff`;
  }

  return null;
}

export function findUser(users: any[], id: string, offset: number = 0) {
  if (users) {
    let len = users.length;
    for (let i = 0; i < len; i++) {
      if (users[i].UID === id) {
        if (i + offset < 0) {
          return users[len - 1];
        } else if (i + offset >= len) {
          return users[0];
        }
        return users[i + offset];
      }
    }
  }
  return null;
}

let completionChartOptions = {
  scales: {
    responsive: true,
    maintainAspectRatio: true,
    yAxes: [
      {
        display: false,
        ticks: {
          min: 0,
          max: 100
        },
        stacked: true
      }
    ],
    xAxes: [
      {
        barThickness: 33,
        gridLines: {
          display: false,
          drawBorder: false
        },
        stacked: true
      }
    ]
  },
  tooltips: {
    callbacks: {
      title: () => {
        return null;
      },
      label: (tooltipItem: any) => {
        return tooltipItem.yLabel + "%";
      }
    }
  }
};
export { completionChartOptions };